import { SxProps, Theme} from '@mui/material';
import { headerBreak } from '@/components/content/Header/styles/break';

export const videoPlayButtonSX: SxProps = { 
	display: 'flex' , 
	color: '#000000', 
	px: 1, 
	width: 'auto', 
	height: '2.4em', 
	alignItems: 'center', 
	fontSize:'16px !important',
	justifyContent: 'center',
	'& svg': {fontSize: 20 }
}

export const pdpVideoContainerSX = ({ isLandscape, pdpPlayerZindex }: { isLandscape:boolean, pdpPlayerZindex: number }): SxProps => ({
	position: "fixed",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	width: headerBreak({ mobile: "93vw", desktop: "55vw" }),
	height: headerBreak({ mobile: isLandscape ? "65vh" : "32vh", desktop: "65vh" }),
	zIndex: pdpPlayerZindex,
	ml:'0 !important',
	boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
	'& .close-video-player-button':{
		p:0.5,
		width:'2em',
		height:'2em',
		position:'absolute',
		top:'-2.4em',
		right:0,
		bgcolor:'#fff',
		borderRadius:'50%',
		'& .MuiButton-startIcon':{
			m:0
		},
		':hover':{
			bgcolor:'#dedede'
		}
	}
});

export const ytContainerSX: SxProps = {
	width: '100%', 
	height:'100%'
}

export const videoPlayerSX = ({ isLandscape }: { isLandscape:boolean}): SxProps => ({
	height: headerBreak({ mobile: isLandscape ? "65vh" : '32vh', desktop: '65vh' }),
	bgcolor:'#3f3f3fab',
	border: '1px solid #4d4d4d',
})

export const videoOverlaySX:SxProps = { 
	position: 'fixed', 
	top: 0, 
	left: 0, 
	marginLeft: '0 !important', 
	opacity: 0.7, 
	backgroundColor: '#000', 
	height: '100vh', 
	width: '100vw', 
	display: 'none', 
	zIndex: 1401,
 }